import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hideCopyrightModal } from "../actions";

class CopyrightModal extends Component {

  render() {
    return (
      <div className="t-modal-backdrop">
        <div className="t-modal-box">
          <div className="t-modal-title">著作権等についてのご注意</div>
          <div className="t-modal-content">
            このデザインは、他者の権利（著作権・商標権・肖像権等）を侵害するものではありません。<br />

            <div className="t-copyright-preview">
              {this.props.images.map((dataUrl, i) => {
                return (
                  <div style={{backgroundColor: this.props.products.currentColor.color}}>
                    <img key={i} src={dataUrl} alt=""  />
                  </div>
                )
              })}
            </div>

          </div>
          <div className="t-modal-footer">
            <div className="t-modal-footer-note">
              他者の権利に関わる問題は発注者の責任でお願い致します。<br />
              当社は他者の権利の侵害がない前提でお引き受けいたします。
            </div>
            <div className="t-modal-buttons">
              <button className="btn btn-success" onClick={this.props.onCheckout}>
                はい
              </button>
              &nbsp;
              <button className="btn btn-default" onClick={this.props.hideCopyrightModal}>いいえ</button>
            </div>

          </div>
        </div>
      </div>
    );
  }
}

export default connect(f => f, {hideCopyrightModal})(CopyrightModal);


// WEBPACK FOOTER //
// ./src/components/CopyrightModal.js